import {Component, DoCheck, OnDestroy, OnInit} from '@angular/core';
import {SecurityState} from '@shared/store/reducers/security.reducer';
import {select, Store} from '@ngrx/store';
import {getUserInfo} from '@shared/store/selectors/security.selector';
import {take, takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {DataFactoryPipeline, DataFactorySubscription} from '@features/admin-panel/models/data-factory.model';
import {Guid} from 'guid-typescript';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {CommandService} from '@core/services/command.service';
import {FormBuilder, Validators} from '@angular/forms';
import {PlatformCommand} from '@shared/commands/command-base';
import {AdminPanelApiService} from '@features/admin-panel/services/admin-panel-api.service';
import {CompanyModel} from '@features/admin-panel/models/company.model';
import {MatSelectChange} from '@angular/material/select';

@Component({
    standalone: false,
    selector: 'app-data-factory',
  templateUrl: './data-factory.component.html',
  styleUrls: ['./data-factory.component.scss']
})
export class DataFactoryComponent implements OnInit, OnDestroy, DoCheck {
  companyId: string;
  private unSubscribe$ = new Subject<void>();
  dataFactorySubscription: DataFactorySubscription;
  dataFactoryPipelines: DataFactoryPipeline[];
  isFactorySubscriptionAvailable: boolean;
  isValid: boolean;
  breadcrumbs: BreadcrumbModel[];
  shouldPipelinesVisible: boolean;
  companyList: CompanyModel[];
  constructor(private securityStore: Store<SecurityState>,
              private platformQueryService: PlatformQueryService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private commandService: CommandService,
              private snackBarService: SnackBarService,
              private formBuilder: FormBuilder,
              private adminPanelApiService: AdminPanelApiService) {
    this.dataFactorySubscription = new DataFactorySubscription();
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id: 'AdminPanel',
        title: 'Admin Panel',
        type: 'AdminPanel',
        relativeUrl: 'admin-panel/data-factory',
      }, <BreadcrumbModel>{
        id: 'DataFactory',
        title: 'Data Factory',
        type: 'DataFactory',
        relativeUrl: 'admin-panel/data-factory',
      },
    ];
  }

  ngOnInit(): void {
    this.adminPanelApiService.getAllCompanies().pipe(take(1)).subscribe(response => {
      this.companyList = response;
      if (this.companyList.length === 0) {
        this.snackBarService.showInformation(`No Company Found`);
      } else {
        this.companyId = this.companyList[0].companyId;
        this.getDataFactoryDetails();
      }
    }, err => {
      this.snackBarService.showError(`Unable to fetch company information`);
      console.error(err);
    });
    // this.securityStore.pipe(select(getUserInfo), takeUntil(this.unSubscribe$)).subscribe(userInfo => {
    //   this.companyId = userInfo.companyId;
    //   this.getDataFactoryDetails();
    // }, err => {
    //   console.error(err);
    // });
  }
  ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  private getDataFactoryDetails() {
    if (this.companyId === null || this.companyId === '') { return; }
    this.fuseSplashScreenService.show();
    this.initializeValues();
    const query = new PlatformQuery();
    query.api = 'AdminPanelApi';
    query.name = 'DataFactoryQuery';
    query.fieldValues['companyId'] = this.companyId;
    query.isCamelCase = true;
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(res => {
      this.fuseSplashScreenService.hide();
      this.isFactorySubscriptionAvailable = res.fieldValues['IsFactorySubscriptionAvailable'];
      if (this.isFactorySubscriptionAvailable) {
        this.dataFactorySubscription = res.fieldValues['DataFactorySubscription'];
        this.dataFactoryPipelines = res.fieldValues['DataFactoryPipelines'];
      }
    }, err => {
      this.fuseSplashScreenService.hide();
      this.snackBarService.showError('Unable to Fetch Data Factory Information.');
      console.error(err);
    });
  }

  ngDoCheck() {
    this.isValid = this.checkValidation();
  }
  submit() {
    this.fuseSplashScreenService.show();
    const command = new PlatformCommand('AddUpdateDataFactoryCommand', 'AdminPanelApi');
    command.fieldValues['companyId'] = this.companyId;
    command.isCamelCase = true;
    command.fieldValues['dataFactoryPipelines'] = this.dataFactoryPipelines;
    command.fieldValues['dataFactorySubscription'] = this.dataFactorySubscription;
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(res => {
      this.fuseSplashScreenService.hide();
      this.getDataFactoryDetails();
    }, err => {
      this.fuseSplashScreenService.hide();
      console.error(err);
      this.snackBarService.showError('Can not process the pipeline at the moment');
    });
  }
  checkValidation() {
    if (this.dataFactorySubscription.dataFactoryId == null &&
    this.dataFactorySubscription.subscriptionId == null && this.dataFactorySubscription.resourceGroupId == null ||
      ( this.dataFactorySubscription.dataFactoryId === '' ||
        this.dataFactorySubscription.subscriptionId === '' ||
        this.dataFactorySubscription.resourceGroupId === '')) {
      return false;
    }
    return true;
  }

  onSelectionChange($event: MatSelectChange) {
    console.log(`companyId: ${this.companyId}`);
    this.getDataFactoryDetails();
  }
  initializeValues() {
    this.dataFactorySubscription = new DataFactorySubscription();
    this.dataFactoryPipelines = [];
  }
}
